import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import mainImage from '../../../assets/unilever-media/landing-page-girl-2.png';
import Header from '../Header';
import Preview from '../Preview';
import { generateRandomAlphaNumeric } from '../../../Utils/alphaNumeric';
import camera from "../../../assets/unilever-media/camera.png"
import image from  "../../../assets/unilever-media/image.png"
import { logData } from '../../../Services/APIs/scan';
import FileTypeErrorPopup from '../FileTypeErrorPopup';

const UsageInstructions = () => {
  const navigate = useNavigate();
  const [showPreview, setShowPreview] = useState(false);
  const [imageDataUri, setImageDataUri] = useState(null);
  const [showFileTypeError, setShowFileTypeError] = useState(false);
  const uid = JSON.parse(localStorage.getItem("usertpi")|| "{}").usertpi;
  const company = JSON.parse(localStorage.getItem("companyBucket")|| "{}").companyBucket;


  useEffect(() => {
    const permissions = localStorage.getItem("privacyAccepted");
    const isScanCompleted = localStorage.getItem("isVyesScanCompleted");
    
    if (!company || !uid || !permissions || isScanCompleted) {
      navigate("/unilever");
    }
    logData({ uid,company : company, message: "visited usage instructions" })

  }, [])


  const handleCameraClick = () => {
    logData({uid, company, message: "moving to capture photo"})
    navigate('/unilever/camera-capture');
  };

  const handleImageUpload = (event) => {
    logData({uid, company, message: "uploading photo from files"})
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (allowedTypes.includes(file.type)) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImageDataUri(reader.result);
          setShowPreview(true);
        };
        reader.readAsDataURL(file);
      } else {
        setShowFileTypeError(true);
      }
    }
  };

  const handleRetake = () => {
    logData({uid, company, message: "re-taking the photo"})
    setShowPreview(false);
    setImageDataUri(null);
  };

  const closeFileTypeErrorPopup = () => {
    setShowFileTypeError(false);
  };

  if (showPreview) {
    return <Preview imageDataUri={imageDataUri} onRetake={handleRetake} goBack={handleRetake} />;
  }

  return (
    <div className="bg-gradient-to-t from-[#570103] to-[#9F6D6E] min-h-full  flex flex-col items-center text-white">
      {showFileTypeError && <FileTypeErrorPopup onClose={closeFileTypeErrorPopup} />}
      <Header />
      <h1 className="text-4xl text-center font-CirceRounded-Regular text-white md:text-5xl">Usage Instruction</h1>
      <p className="mt-2 px-5 text-center font-CirceRounded-Light md:text-xl">
        Use the ShadeScan AI to visualize how your smile can transform with 5 shades whiter teeth.
      </p>

          <div className="relative mt-2 flex-grow flex-shrink-0 flex justify-center items-center  px-5 ">
        <img src={mainImage} alt="Woman smiling"
          className="w-full h-full max-h-[55vh] object-contain "
          />
      </div>
      <div className="w-full mt-4 p-4 space-y-4 flex flex-col items-center ">
        <button
          onClick={handleCameraClick}
          className="w-full bg-[#D50026] text-white py-3 rounded-full font-CirceRounded-Regular text-base font-semibold flex items-center justify-center md:text-xl md:w-1/2"
        >
          <img src={camera} alt="camera" className="mr-2 h-4" />
          Scan with camera
        </button>
        <input
          type="file"
          accept="image/png, image/jpeg, image/jpg"
          onChange={handleImageUpload}
          style={{ display: 'none' }}
          id="imageUploadInput"
        />
        <button
          onClick={() => {
            document.getElementById('imageUploadInput').click()
          }}
          className="w-full font-CirceRounded-Regular text-base bg-white text-[#D50026] py-3 rounded-full font-semibold flex items-center justify-center md:text-xl md:w-1/2"
        >
          <img src={image} alt="upload" className="mr-2 h-4" />
          Upload a photo
        </button>
      </div>
    </div>
  );
};

export default UsageInstructions;